import '@dui/components/icons/dui-icon.scss';

import DuiBookCover from '@dui/components/dui-book-cover/dui-book-cover.vue';
import DuiIconArrowRight from '@dui/components/icons/dui-icon-arrow-right/dui-icon-arrow-right.vue';
import DuiIconBroadcast from '@dui/components/icons/dui-icon-broadcast/dui-icon-broadcast.vue';
import DuiIconCross from '@dui/components/icons/dui-icon-cross/dui-icon-cross.vue';
import DuiIconFacebook from '@dui/components/icons/dui-icon-facebook/dui-icon-facebook.vue';
import DuiIconGoogle from '@dui/components/icons/dui-icon-google/dui-icon-google.vue';
import DuiIconMenu from '@dui/components/icons/dui-icon-menu/dui-icon-menu.vue';
import DuiIconStar from '@dui/components/icons/dui-icon-star/dui-icon-star.vue';
import DuiIconDiscover from '@dui/components/icons/dui-icon-discover/dui-icon-discover.vue';
import DuiIconSubmit from '@dui/components/icons/dui-icon-submit/dui-icon-submit.vue';
import DuiIconTriangle from '@dui/components/icons/dui-icon-triangle/dui-icon-triangle.vue';
import DuiIconDashboard from '@dui/components/icons/dui-icon-dashboard/dui-icon-dashboard.vue';
import DuiIconSearch from '@dui/components/icons/dui-icon-search/dui-icon-search.vue';
import DuiLoadingIndicator from '@dui/components/dui-loading-indicator/dui-loading-indicator.vue';
import DuiSearchInput from '@dui/components/dui-search-input/dui-search-input.vue';
import DuiPagination from '@dui/components/dui-pagination/dui-pagination.vue';
import DuiRating from '@dui/components/dui-rating/dui-rating.vue';
import DuiReviewRating from '@dui/components/dui-review-rating/dui-review-rating.vue';

export default {
  DuiBookCover,
  DuiIconArrowRight,
  DuiIconBroadcast,
  DuiIconCross,
  DuiIconFacebook,
  DuiIconGoogle,
  DuiIconMenu,
  DuiIconStar,
  DuiIconDiscover,
  DuiIconSubmit,
  DuiIconDashboard,
  DuiIconSearch,
  DuiIconTriangle,
  DuiLoadingIndicator,
  DuiSearchInput,
  DuiPagination,
  DuiRating,
  DuiReviewRating,
};
